import React, { useEffect, useState } from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';
import { useDispatch, useSelector } from "react-redux";
import { fetchAllProjects } from './../../../../../store/slices/projectsSlice';
import { fetchAllCompletedTasks } from './../../../../../store/slices/ProjectCompletedTask';
import { fetchAllOngoingTasks } from './../../../../../store/slices/ProjectOngoingTask';
import { fetchAllAssignedTasks } from './../../../../../store/slices/ProjectAssignedTaskSlice';
import { getAllProjectRequests } from './../../../../../store/slices/projectApprovedTaskSlice';
import { fetchAllTasks } from './../../../../../store/slices/projectRequestedSlice';

const EmployeeReviewProjectGraph = () => {
    const dispatch = useDispatch()

    // const { requestedTasks } = useSelector((state) => state.projectRequestedTask);
    // const { allProjects } = useSelector((state) => state.projectApprovedTask);
    // const { tasks } = useSelector((state) => state.assignedTasks);
    // const { allOngoingTasks } = useSelector((state) => state.projectOngoingTasks);
    // const { completeTask } = useSelector((state) => state.completedTasks);
    const [totalTaskCount, settotalTaskCount] = useState("");
    const [totalRequestedCount, settotalRequestedCount] = useState("");
    const [totalAssignCount, settotalAssignCount] = useState("");
    const [totalOngoingCount, settotalOngoingCount] = useState("");
    const [totalApprovedCount, settotalApprovedCount] = useState("");
    const [totalCompletedCount, settotalCompletedCount] = useState("");

    const email = localStorage.getItem("email");


    const { projects } = useSelector(state => state.projects)

    useEffect(() => {
        dispatch(fetchAllProjects())
    }, [dispatch])




    useEffect(() => {
        const totalWorkEntriesCount = projects.reduce((total, project) => {
            return total + (project.WorkEntries?.length || 0);
        }, 0);

        const requestedProjects = projects.filter(
            project => project.ManagerStatus === "project requested" && project.AssignedManagerEmail === email
        );
        const AssignProjects = projects.filter(
            project => project.ManagerStatus === "project assign" && project.AssignedManagerEmail === email
        );
        const ongoingProjects = projects.filter(
            project => project.ManagerStatus === "project ongoing" && project.AssignedManagerEmail === email
        );
        const approvedProjects = projects.filter(
            project => project.ManagerStatus === "project approved" && project.AssignedManagerEmail === email
        );
        const completedProjects = projects.filter(
            project => project.ManagerStatus === "completed" && project.AssignedManagerEmail === email
        );

      
        settotalTaskCount(totalWorkEntriesCount)
        settotalRequestedCount(requestedProjects.length)
        settotalAssignCount(AssignProjects.length)
        settotalApprovedCount(approvedProjects.length)
        settotalOngoingCount(ongoingProjects.length)
        settotalCompletedCount(completedProjects.length)
    }, [projects, email])










    useEffect(() => {
        dispatch(fetchAllTasks());
        dispatch(getAllProjectRequests());
        dispatch(fetchAllAssignedTasks());
        dispatch(fetchAllOngoingTasks());
        dispatch(fetchAllCompletedTasks());

    }, [dispatch]);

    // const groupedArray = Object.values(
    //     requestedTasks.reduce((acc, task) => {
    //         const project = task.projectName;
    //         if (!acc[project]) {
    //             acc[project] = {
    //                 projectName: project,
    //                 TypeService: task.TypeService,
    //                 tasks: []
    //             };
    //         }
    //         acc[project].tasks.push(task);
    //         return acc;
    //     }, {})
    // );

    // const groupedArrayallProjects = Object.values(
    //     allProjects.reduce((acc, task) => {
    //         const project = task.projectName;
    //         if (!acc[project]) {
    //             acc[project] = {
    //                 projectName: project,
    //                 TypeService: task.TypeService,
    //                 tasks: []
    //             };
    //         }
    //         acc[project].tasks.push(task);
    //         return acc;
    //     }, {})
    // );

    // const groupedArraytasks = Object.values(
    //     tasks.reduce((acc, task) => {
    //         const project = task.projectName;
    //         if (!acc[project]) {
    //             acc[project] = {
    //                 projectName: project,
    //                 TypeService: task.TypeService,
    //                 tasks: []
    //             };
    //         }
    //         acc[project].tasks.push(task);
    //         return acc;
    //     }, {})
    // );

    // const groupedArrayongoingtasks = Object.values(
    //     allOngoingTasks.reduce((acc, task) => {
    //         const project = task.projectName;
    //         if (!acc[project]) {
    //             acc[project] = {
    //                 projectName: project,
    //                 TypeService: task.TypeService,
    //                 tasks: []
    //             };
    //         }
    //         acc[project].tasks.push(task);
    //         return acc;
    //     }, {})
    // );

    // const groupedArraycompleteTask = Object.values(
    //     completeTask.reduce((acc, task) => {
    //         const project = task.projectName;
    //         if (!acc[project]) {
    //             acc[project] = {
    //                 projectName: project,
    //                 TypeService: task.TypeService,
    //                 tasks: []
    //             };
    //         }
    //         acc[project].tasks.push(task);
    //         return acc;
    //     }, {})
    // );

    // const Requests = groupedArray?.length
    // const Approved = groupedArrayallProjects?.length
    // const Assigned = groupedArraytasks?.length
    // const Ongoing = groupedArrayongoingtasks?.length
    // const Completed = groupedArraycompleteTask?.length

    // const series = [Requests, Approved, Assigned, Ongoing, Completed];

    const data = [
        { name: 'Requested Projects', value: totalRequestedCount },
        // { name: 'input received', value: Requests },
        { name: 'Approved Projects', value: totalApprovedCount },
        { name: 'Assigned Projects', value: totalAssignCount },
        { name: 'Ongoing Projects', value: totalOngoingCount },
        { name: 'Completed Projects', value: totalCompletedCount },


    ];
    const COLORS = [
        '#0b53e5', '#1e73f0', '#4191f2', '#63aef4',
        '#85ccf6', '#a7e9f8', '#c9f6fa', '#d5fafd', '#e0feff'
    ];

    const renderCustomLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
        const RADIAN = Math.PI / 180;
        const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
        const x = cx + radius * Math.cos(-midAngle * RADIAN);
        const y = cy + radius * Math.sin(-midAngle * RADIAN);

        return (
            <text
                x={x}
                y={y}
                fill="#fff"
                textAnchor="middle"
                dominantBaseline="central"
                fontSize={10}
            >
                {`${data[index].value}`}
            </text>
        );
    };
    return (
        <>
        <div className='flex flex-col w-1/2 bg-white rounded-md'> 
            <div className='p-1 pl-2 font-semibold'>
                <h1 >
                    All Projects
                </h1>
            </div>
            <hr />
            <div style={{ position: 'relative', width: '100%', height: '450px' }} className='bg-white rounded-md'>
                {/* Center background circle */}
                <div style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    width: '130px', // match your innerRadius (approx.)
                    height: '130px',
                    backgroundColor: '#156082', // your desired background color
                    borderRadius: '50%',
                    transform: 'translate(-50%, -50%)',
                    zIndex: 1, // make sure it's behind the text
                    pointerEvents: 'none'
                }}></div>

                {/* Center Text */}
                <div style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    color: '#ffffff',
                    zIndex: 2,
                    pointerEvents: 'none'
                }}>
                    {totalTaskCount}
                </div>

                <ResponsiveContainer>
                    <PieChart>
                        <Pie
                            data={data}
                            cx="50%"
                            cy="50%"
                            innerRadius="30%"
                            outerRadius="70%"
                            dataKey="value"
                            startAngle={90}
                            endAngle={-270}
                            label={renderCustomLabel}
                            labelLine={false}
                        >
                            {data.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                            ))}
                        </Pie>
                        <Tooltip
                            wrapperStyle={{ zIndex: 9999 }} // Force tooltip to appear above everything
                            contentStyle={{ backgroundColor: '#fff', borderRadius: '8px', border: '1px solid #ccc' }}
                            formatter={(value, name) => [`${value}`, `${name}`]}
                        />
                    </PieChart>
                </ResponsiveContainer>
            </div>
            </div>
        </>
    )
}

export default EmployeeReviewProjectGraph